"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkFormat = void 0;
const assertFormat_1 = require("./assertFormat");
const errors_1 = require("./errors");
/**
 * A checker to verify if a RID matches a given format.
 * Example:
 * ```
 * checkFormat('sharefile:account-123/packageinstall-456',{system: 'sharefile',segments:['account','packageinstall']}) // true
 * checkFormat('sharefile:account-123/packageinstall-456',{system:'salesforce',segments:['publisher','feed','packageinstall']}) // false
 * ```
 * @param rid A RID string
 * @param format An object to specify the exact segments and system to match against the given RID.
 * @returns `true` if the provided {@link rid} matches the provided {@link format}, `false` otherwise.
 * @throws if there are any unhandled errors.
 */
function checkFormat(rid, format) {
    try {
        (0, assertFormat_1.assertFormat)(rid, format);
        return true;
    }
    catch (error) {
        if (!(error instanceof errors_1.FormatAssertionError)) {
            throw error;
        }
        else {
            return false;
        }
    }
}
exports.checkFormat = checkFormat;
//# sourceMappingURL=checkFormat.js.map